import { Icon, Tooltip } from 'antd';
import React, { useContext } from 'react';

import { getRefundItems, IInvoice } from 'src/apis/Reporting/ChargeHistory';
import { formatPrice } from 'src/utils';
import styles from './Totals.module.css';
import RefundFormContext from './RefundFormContext';

export interface IProps {
  invoice: IInvoice;
  totalRefund: number;
}

const calculatePreviouslyRefunded = (invoice: IInvoice) =>
  getRefundItems(invoice).reduce((collector, item) => collector + item.amount, 0);

const Totals: React.FC<IProps> = ({invoice, totalRefund}) => {
  const {currency} = useContext(RefundFormContext);
  const previouslyRefundedCents = calculatePreviouslyRefunded(invoice);

  return <div className={styles.totals}>
    <div>
      Previous Refunds:{' '}
      <Tooltip title='The total amount refunded to date for this invoice.'>
        <Icon type='info-circle' theme='filled'/>
      </Tooltip>{' '}
      {formatPrice(currency, previouslyRefundedCents)}
    </div>
    <div>
      Total Refund:{' '}
      <Tooltip title='The total refund does not include sales tax.'>
        <Icon type='info-circle' theme='filled'/>
      </Tooltip>{' '}
      {(formatPrice(currency, totalRefund))}
    </div>
  </div>
}

export default Totals;
